import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useDispatch } from "react-redux";
import bin from "../assets/images/bin.png";
import MainpageLoader from "../component/common-component/Loaders/MainpageLoader";
import SubmitLoading from "../component/common-component/Loaders/SubmitLoading";
import { CONFIG_COMPONENT_NAME } from "../services/configComponent";

function DeleteParaFAQModal(props) {
  const [Loading, setLoading] = useState(false);
  async function fnDelete() {
    setLoading(true);
    if (props?.type?.type === "parameter") {
      props?.input?.machineconfigparameter?.splice(props?.type?.index, 1);
      const hasValidParaType = props?.input?.machineconfigparameter?.filter(
        (item) => {
          if (!CONFIG_COMPONENT_NAME[item?.paratype]) {
            return item;
          }
        }
      );
      props?.setinput({
        ...props?.input,
        parametershow: hasValidParaType?.length > 0 ? false : true,
        machineconfigparameter: [...props?.input.machineconfigparameter],
      });
    } else if (props?.type?.type === "faq") {
      let updatedData = props?.input?.machinefaqs?.filter(
        (x, i) => i !== props?.type?.index
      );
      props?.setinput({
        ...props?.input,
        machinefaqs: updatedData,
      });
    }
    setLoading(false);
    props.onHide();
  }

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className={`${
        props.isContactDeleteModelClass
          ? "contact-add-or-remove-model delete-modal"
          : "delete-modal"
      } ${props.isdeleteWebhookmodelClass && "delete-webhookmodel"}`}
      backdrop="static"
    >
      {Loading && <MainpageLoader />}
      <Modal.Body>
        <div className="text-center">
          <img src={bin} alt="bin" className="modal-delete-icon" />
          <h4>Are you sure you want to delete?</h4>
          <p>Please confirm if you wish to proceed with deleting this item.</p>
          <div className="d-flex align-items-center gap-2">
            <button className="grey-btn" onClick={props.onHide}>
              No, Keep
            </button>
            <button
              className="red-btn"
              onClick={(e) => {
                fnDelete();
              }}
            >
              {Loading ? (
                // <>
                //   <span>Loading</span>{" "}
                //   <Spinner
                //     className="ms-1"
                //     animation="border"
                //     role="status"
                //     size="sm"
                //   >
                //     <span className="visually-hidden">Loading...</span>
                //   </Spinner>
                // </>
                <SubmitLoading />
              ) : (
                " Yes, Delete"
              )}
            </button>
          </div>
        </div>
      </Modal.Body>
      {/* <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer> */}
    </Modal>
  );
}

export default DeleteParaFAQModal;
